export default "__VITE_ASSET__Xn396QjZ__"